@if (loading()) {
  <div>
    <bit-icon
      name="bwi-spinner"
      class="bwi-spin tw-text-muted"
      [ariaLabel]="'loading' | i18n"
    ></bit-icon>
  </div>
}
@if (profile(); as profile) {
  @if (!loading()) {
    <form [formGroup]="formGroup" [bitSubmit]="submit">
      <div class="tw-grid tw-grid-cols-1 lg:tw-grid-cols-12 tw-gap-6">
        <!-- Profile summary card -->
        <div class="lg:tw-col-span-4">
          <bit-card class="tw-flex tw-h-full tw-flex-col tw-items-center tw-gap-3 tw-text-center">
            <bit-section-header class="tw-w-full tw-justify-center">
              <i class="bwi bwi-user tw-text-muted" aria-hidden="true"></i>
              <h2 bitTypography="h4">{{ "profileSummary" | i18n }}</h2>
            </bit-section-header>
            <dynamic-avatar [text]="avatarUser() | userName" [id]="profile.id" size="2xl">
            </dynamic-avatar>
            <div>
              <p bitTypography="body1" class="!tw-mb-0 tw-font-semibold">
                {{ profile.name || email() }}
              </p>
              <p bitTypography="body2" class="!tw-mb-0 tw-text-muted">{{ email() }}</p>
            </div>
            <button
              startIcon="bwi-pencil-square"
              type="button"
              buttonType="secondary"
              bitButton
              bitFormButton
              appStopClick
              appStopProp
              [bitAction]="openChangeAvatar"
            >
              {{ "customize" | i18n }}
            </button>
          </bit-card>
        </div>

        <!-- Personal data card -->
        <div class="lg:tw-col-span-8">
          <bit-card class="tw-block">
            <bit-section-header class="tw-mb-3">
              <i class="bwi bwi-id-card tw-text-muted" aria-hidden="true"></i>
              <h2 bitTypography="h4">{{ "personalData" | i18n }}</h2>
            </bit-section-header>

            <bit-form-field>
              <bit-label>{{ "name" | i18n }}</bit-label>
              <input bitInput formControlName="name" />
            </bit-form-field>
            <bit-form-field>
              <bit-label>{{ "email" | i18n }}</bit-label>
              <input bitInput [value]="email()" readonly />
            </bit-form-field>

            @if (managingOrganization(); as managingOrganization) {
              <div>
                {{ "accountIsOwnedMessage" | i18n: managingOrganization?.name }}
                <a
                  target="_blank"
                  rel="noopener noreferrer"
                  href="https://bitwarden.com/help/claimed-accounts"
                >
                  <bit-icon name="bwi-question-circle"></bit-icon>
                </a>
              </div>
            }
            @if (fingerprintMaterial(); as fingerprintMaterial) {
              @if (userPublicKey(); as userPublicKey) {
                <app-account-fingerprint
                  [fingerprintMaterial]="fingerprintMaterial"
                  [publicKeyBuffer]="userPublicKey"
                  fingerprintLabel="{{ 'yourAccountsFingerprint' | i18n }}"
                >
                </app-account-fingerprint>
              }
            }

            <button bitButton bitFormButton type="submit" buttonType="primary" class="tw-mt-2">
              {{ "save" | i18n }}
            </button>
          </bit-card>
        </div>
      </div>
    </form>
  }
}
